import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";
import { PartyService } from "../../../../services/SubmissionService";

export default function Party({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const never = "never" as const;
    const [updatedParty, setUpdatedParty] = useState(submission.parties ?? []);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedParty(submission.parties ?? []);
    }, [submission]);

    const onSaveClick = useCallback(async () => {
        /* 
        setSaving(true);
        AttorneyService.SaveProfile({ body: request }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    if (resp.data?.length === 1) {
                        onSearchComplete(request, resp.data[0]);
                    } else if (resp.data && resp.data?.length > 1) {
                        //We will need to show the modal to select which case
                        setSearchResults(resp.data ?? []);
                    } else {
                        setErrorMessage(resp.errorMessage ?? "No case found");
                    }
                } else {
                    console.log(resp.errorMessage);
                    setErrorMessage(resp.errorMessage ?? "No case found");
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
        */
    }, [updatedParty]);

    const refreshData = () => {
        PartyService.getAll({
            id: submission?.id ?? "",
        }).then(
            (resp) => {
                if (resp?.successful && resp?.data !== null) {
                    setUpdatedParty(resp?.data ?? updatedParty);
                    console.log(resp?.data);
                } else {
                    setUpdatedParty(updatedParty);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "Name",
                                field: "name",
                            },
                            {
                                title: "PartyType",
                                field: "partyType",
                            },
                            {
                                title: "First Name",
                                field: "firstName",
                            },
                            {
                                title: "Middle Name",
                                field: "middleName",
                            },
                            {
                                title: "Last Name",
                                field: "lastName",
                            },
                            {
                                title: "Street Address",
                                field: "address.streetAddress",
                            },
                            {
                                title: "Unit",
                                field: "address.unit",
                            },
                            {
                                title: "City",
                                field: "address.city",
                            },
                            {
                                title: "State",
                                field: "address.state",
                            },
                            {
                                title: "Postal Code",
                                field: "address.zip",
                            },
                        ]}
                        data={updatedParty}
                        title="Party"
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    const request = {
                                        name: newData?.name,
                                        partyType: newData?.partyType,
                                        firstName: newData?.firstName,
                                        middleName: newData?.middleName,
                                        lastName: newData?.lastName,
                                        streetAddress:
                                            newData?.address?.streetAddress,
                                        unit: newData?.address?.unit,
                                        city: newData?.address?.city,
                                        state: newData?.address?.state,
                                        postal: newData?.address?.zip,
                                    };
                                    PartyService.add({
                                        id: submission?.id ?? "",
                                        body: request,
                                    }).then(
                                        (resp) => {
                                            if (resp?.successful) {
                                                refreshData();
                                            } else {
                                                setUpdatedParty(
                                                    submission?.parties ?? []
                                                );
                                            }
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    const request = {
                                        id: oldData?.id,
                                        name: newData?.name,
                                        partyType: newData?.partyType,
                                        firstName: newData?.firstName,
                                        middleName: newData?.middleName,
                                        lastName: newData?.lastName,
                                        streetAddress:
                                            newData?.address?.streetAddress,
                                        unit: newData?.address?.unit,
                                        city: newData?.address?.city,
                                        state: newData?.address?.state,
                                        postal: newData?.address?.zip,
                                    };
                                    PartyService.update({
                                        id: oldData?.submissionID ?? "",
                                        body: request,
                                    }).then(
                                        (resp) => {
                                            if (resp?.successful) {
                                                refreshData();
                                            } else {
                                                setUpdatedParty(
                                                    submission?.parties ?? []
                                                );
                                            }
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    const request = {
                                        id: oldData?.id,
                                        name: oldData?.name,
                                        partyType: oldData?.partyType,
                                        firstName: oldData?.firstName,
                                        middleName: oldData?.middleName,
                                        lastName: oldData?.lastName,
                                        streetAddress:
                                            oldData?.address?.streetAddress,
                                        unit: oldData?.address?.unit,
                                        city: oldData?.address?.city,
                                        state: oldData?.address?.state,
                                        postal: oldData?.address?.zip,
                                    };
                                    PartyService.delete({
                                        id: oldData.submissionID ?? "",
                                        body: request,
                                    }).then(
                                        (resp) => {
                                            if (resp?.successful) {
                                                refreshData();
                                            } else {
                                                setUpdatedParty(
                                                    submission?.parties ?? []
                                                );
                                            }
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
